import { getResourceUrl } from '../src/globals';
import { externalExtensions, getExtensionEntryKey } from './externalExtensions';

import { av } from "@adsk/lmv";
const theExtensionManager = av.theExtensionManager;

const ext = BUILD_FLAG__MINIFIED_BUILD ? 'min.js' : 'js';

// Register them all
externalExtensions.forEach((ee) => {

  let key = getExtensionEntryKey(ee);
  let filePath = getResourceUrl(`extensions/${key}/${key}.${ext}`);
  let dependencies = ee.dependencies;
  ee.ids.forEach((id) => {
    theExtensionManager.registerExternalExtension(id, filePath, dependencies);
  });
});